import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const Profile = ({ size = 20, color = colors('neutral', 3) }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0003 8.74899C11.8672 8.74899 13.3805 7.23817 13.3805 5.37449C13.3805 3.51081 11.8672 2 10.0003 2C8.13349 2 6.62012 3.51081 6.62012 5.37449C6.62012 7.23817 8.13349 8.74899 10.0003 8.74899Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16 17.0002V15.7904C16 13.1214 13.8316 10.9567 11.1581 10.9567H8.84192C6.16838 10.9567 4 13.1214 4 15.7904V17.0002"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Profile;
